import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/text.scss'
import 'assets/style/elements/list-title.scss'

// elements
import Heading from 'components/elements/Heading'
import Line from 'components/elements/Line'

function ListTitle({ children, title, subtitle, count = null, className = '', border = false, level = 1 }) {
  let headingClass = 'f-noto f-16'
  if (level === '2') {
    headingClass = 'f-noto f-14 f-medium'
  } else {
    headingClass = 'f-noto f-16 f-bold'
  }
  return (
    <>
      <header className={'list-title ' + className}>
        <div className="left flex2">
          <Heading level="2" className={headingClass}>
            {title || 0}
          </Heading>
          {subtitle && <span className="count ml4">{subtitle}</span>}
          {count !== null && <span className="count ml8 mt2">{parseInt(count).toLocaleString()} 건</span>}
        </div>
        {typeof children !== 'undefined' && <div className="right">{children}</div>}
      </header>
      {border !== false && <Line className="mt8" size="1" color="gray" />}
    </>
  )
}

export default ListTitle
